export default function Step1() {
    return (
        <svg width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M33.583 10.833H36.833C39.2262 10.833 41.1663 12.7731 41.1663 15.1663V41.1663C41.1663 43.5596 39.2262 45.4996 36.833 45.4996H15.1663C12.7731 45.4996 10.833 43.5596 10.833 41.1663V15.1663C10.833 12.7731 12.7731 10.833 15.1663 10.833H18.4163"
                stroke="#7293F7"
                strokeWidth="2.5"
            />
            <path d="M19.5 29.6491L24.5175 34.6667L33.1842 26" stroke="#7293F7" strokeWidth="2.5" />
            <path
                d="M19.4997 7.54H32.4997C33.1219 7.54 33.6263 8.04442 33.6263 8.66667V13C33.6263 13.6222 33.1219 14.1267 32.4997 14.1267H19.4997C18.8774 14.1267 18.373 13.6222 18.373 13V8.66667C18.373 8.04443 18.8774 7.54 19.4997 7.54Z"
                stroke="#7293F7"
                strokeWidth="2.08"
            />
        </svg>
    );
}
